import { render, staticRenderFns } from "./AlertsTable.vue?vue&type=template&id=282d0b22&scoped=true&"
import script from "./AlertsTable.vue?vue&type=script&lang=js&"
export * from "./AlertsTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertsTable.vue?vue&type=style&index=0&id=282d0b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282d0b22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('282d0b22')) {
      api.createRecord('282d0b22', component.options)
    } else {
      api.reload('282d0b22', component.options)
    }
    module.hot.accept("./AlertsTable.vue?vue&type=template&id=282d0b22&scoped=true&", function () {
      api.rerender('282d0b22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/AlertsTable.vue"
export default component.exports